import * as React from 'react';
import { connect } from 'react-redux';
import { goBack } from 'react-router-redux';
import * as queryString from 'query-string';
import {
  Title,
  IconButton,
  RouteWrapper,
  ReservationCreateForm,
} from '../../components';

interface Props {
  reservations: any;
  dispatch: Function;
}

class Route extends React.Component<Props> {
  render() {
    const query = queryString.parse(window.location.search);
    let breadcrumbs = [{ link: `/reservations/create`, text: 'Day View' }];
    if (query && query.start_date) {
      breadcrumbs = [
        { link: '/history', text: 'History' },
        { link: `/history/${query.start_date}`, text: 'Day View' },
        { link: `/reservations/create`, text: 'Create Reservation' },
      ];
    }
    return (
      <RouteWrapper
        title="New Reservation"
        requireAuth
        requirePermission="MANAGE_RESERVATIONS"
        breadcrumbs={breadcrumbs}
      >
        <div className="container">
          <div className="levels">
            <div className="level">
              <div className="level-left">
                <div>
                  <Title>New Reservation</Title>
                </div>
              </div>
              <div className="level-right">
                <IconButton
                  icon="undo"
                  className="is-default is-pulled-right"
                  handleClick={() => {
                    this.props.dispatch(goBack());
                  }}
                >
                  Return
                </IconButton>
              </div>
            </div>
          </div>
          <div className="columns is-centered">
            <div className="column is-12-desktop is-7-widescreen">
              <ReservationCreateForm
                showHeading={false}
                onUpdate={() => {
                  window.history.back();
                }}
              />
            </div>
          </div>
        </div>
      </RouteWrapper>
    );
  }
}

const mapStateToProps = ({ reservations }) => ({
  reservations,
});

export default connect(mapStateToProps)(Route);
